import { clearSession } from "../Redux/action/sessionAction";
import store from "../Redux/store";

const INVALID_SESSION_NAME = "Invalid Session ID";
const INVALID_SESSION_NUMBER = 11;

let isLoggingOut = false;
let interceptorInitialized = false;

export const isInvalidSessionPayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return false;
  }

  const hasInvalidName = payload.name === INVALID_SESSION_NAME;
  const hasInvalidNumber = Number(payload.number) === INVALID_SESSION_NUMBER;

  return hasInvalidName && hasInvalidNumber;
};

export const forceLogoutForInvalidSession = () => {
  if (isLoggingOut) {
    return;
  }

  isLoggingOut = true;

  localStorage.removeItem("sessionState");
  localStorage.removeItem("sessionId");
  localStorage.removeItem("userId");
  localStorage.removeItem("userName");

  store.dispatch(clearSession());

  const currentPath = window.location.pathname;
  if (currentPath !== "/authentication/sign-in") {
    window.location.assign("/authentication/sign-in");
  }
};

export const setupInvalidSessionInterceptor = (axiosInstance) => {
  if (!axiosInstance || interceptorInitialized) {
    return;
  }

  interceptorInitialized = true;

  axiosInstance.interceptors.response.use(
    (response) => {
      if (isInvalidSessionPayload(response?.data)) {
        forceLogoutForInvalidSession();
        return Promise.reject(new Error(INVALID_SESSION_NAME));
      }

      return response;
    },
    (error) => {
      if (isInvalidSessionPayload(error?.response?.data)) {
        forceLogoutForInvalidSession();
      }

      return Promise.reject(error);
    }
  );
};
